<div class="d-flex w-100 justify-content-between">
    <h2 mat-dialog-title>
        TVM Geschiedenis
    </h2>
    <button mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <table [dataSource]="ttmHistory$ | async" class="w-100 mb-4" mat-table matSort matSortActive="created_at" matSortDirection="desc">
        <ng-container matColumnDef="created_at">
            <th *matHeaderCellDef mat-header-cell mat-sort-header width="200">Aangemaakt</th>
            <td *matCellDef="let ticket" class="text-right pr-3" mat-cell> {{ticket.created_at | date: 'EEE d MMM yyyy HH:mm'}}</td>
        </ng-container>
        <ng-container matColumnDef="field">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Veld</th>
            <td *matCellDef="let ticket" mat-cell> {{translate.get(ticket.field) ?? ticket.field}}</td>
        </ng-container>
        <ng-container matColumnDef="old_value">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Oude waarde</th>
            <td *matCellDef="let ticket" mat-cell>{{ticket.old_value}}</td>
        </ng-container>
        <ng-container matColumnDef="new_value">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Nieuwe waarde</th>
            <td *matCellDef="let ticket" mat-cell> {{ticket.new_value}}</td>
        </ng-container>
        <ng-container matColumnDef="distance" *ngIf="displayedColumns.includes('distance')">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Afstand</th>
            <td *matCellDef="let ticket" mat-cell> {{(ticket.distance | number:'1.0-2') ?? '-'}} km</td>
        </ng-container>
        <ng-container matColumnDef="changed_by_id">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Door</th>
            <td *matCellDef="let ticket" mat-cell> {{ticket.changed_by?.name ?? 'Onbekend'}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell>Acties</th>
            <td *matCellDef="let ticket" mat-cell>
                <div *ngIf="hasLocation(ticket)" class="d-flex gap-2">
                    <button mat-icon-button matTooltip="Tonen op Google Maps" (click)="openGoogleMaps(ticket)">
                        <mat-icon>public</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>

    <p class="footnote" *ngIf="displayedColumns.includes('distance')">
        <small>* De afstand toont hoe ver de vakman bij de statuswijziging van de maatregel verwijderd was</small>
    </p>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-stroked-button (click)="showOnInternalMap()">
        Toon statuslocaties op kaart
    </button>
</mat-dialog-actions>
